import { type AxiosInstance, type AxiosRequestConfig, AxiosHeaders } from 'axios';

import { appConfig } from '../../../../appConfig';
import axiosClientFactory from '../clients/clientFactory';

const getDirectRecipeAxiosClient = (accessToken: string | null): AxiosInstance => {
    const config: AxiosRequestConfig = {
        baseURL: appConfig.coopSettings.recipe.apiUrl,
        params: {
            'api-version': 'v1',
        },
    };

    const headers = new AxiosHeaders();
    if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
    }

    config.headers = headers;

    const client = axiosClientFactory.createDirectApiClient(config);
    return client;
};

export default getDirectRecipeAxiosClient;
